import { Image } from '@ahafood/ui/components/image';
import React from 'react';

type NewGreetingCardProps = {
  userName?: string;
};

export default function NewGreetingCard({ userName }: NewGreetingCardProps) {
  const displayName =
    userName && userName !== 'Ahamove User' ? userName : 'Bạn';
  return (
    <div className="pt-4 relative">
      <div className="absolute top-3 right-3">
        <Image
          src="/static/images/ai-icon.png"
          alt="Chatbot Detail"
          width={33}
          height={24}
        />
      </div>
      <div className="flex text-xs items-center font-medium bg-gradient-to-b from-primary-50 via-[#a82200] to-secondary-50 bg-clip-text text-transparent w-fit">
        Một mình? Có Amori! Một bữa có{' '}
        <Image
          width={71}
          height={21}
          className="ml-1"
          src={'/static/images/solo-meal.png'}
          alt={'Solo Meal'}
        />
      </div>
      <div className="text-xl font-bold bg-gradient-to-r from-[#A80036] via-red-40 to-secondary-50 bg-clip-text text-transparent w-fit">
        {displayName} muốn ăn gì?
      </div>
    </div>
  );
}
